import React, { useContext, useEffect, useState, forwardRef } from 'react'
import { motion } from 'framer-motion'
import FlipMove from 'react-flip-move'
import { NotificationProps } from './Notification.types'

import { NotificationContext } from './Notification.context'
import Icon from '../Icon/Icon'
import Portal from '../Portal/Portal'

const Banner = forwardRef<HTMLDivElement>((props: NotificationProps, ref) => {
    const { id, title, message, shallRemove, handleRemove, hideAfter, type = 'primary' } = props
    const [show, setShow] = useState(true)

    const remove = () => {
        handleRemove(id)
    }

    useEffect(() => {
        if (hideAfter) {
            // Set auto delete timer
            setTimeout(() => {
                setShow(false)
            }, hideAfter)
        }
    }, [])

    useEffect(() => {
        if (shallRemove) {
            setShow(false)
        }
    }, [shallRemove])

    useEffect(() => {
        if (!show) {
            setTimeout(() => {
                handleRemove(id)
            }, 1000)
        }
    }, [show])

    const variants = {
        closed: { opacity: 0, y: -100 },
        open: { opacity: 1, y: 0 },
    }

    return (
        <motion.div
            initial={'closed'}
            animate={show ? 'open' : 'closed'}
            variants={variants}
            transition={{
                duration: 0.5,
                bounce: 0.4,
                type: 'spring',
            }}
            ref={ref}
            className={`r-banner-item r-type-${type}`}
        >
            {/*<div className='r-banner-title-container'>*/}
            {/*    <div className='r-title'>{title}</div>*/}
            {/*    <button onClick={remove} style={{ background: 'none', padding: 0, border: 'none', color: 'inherit' }}>*/}
            {/*        <Icon type={'window-close'} size={'sm'} />*/}
            {/*    </button>*/}
            {/*</div>*/}

            <div className='r-banner-body'>{message}</div>
        </motion.div>
    )
})

const BannerWrapper = () => {
    const { banners, deleteBanner } = useContext(NotificationContext)

    if (banners.length < 1) {
        return null
    }

    return (
        <Portal container={document.body}>
            <div data-testid='Banner' className='r-banner-wrapper'>
                {banners.map((n, i) => (
                    <Banner key={n.id} {...n} handleRemove={deleteBanner} />
                ))}
            </div>
        </Portal>
    )
}

export default BannerWrapper
